import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Connects to data-controller="payment-methods-description"
export default class extends Controller {
  static targets = ["description"];
  static values = {
    url: String,
  };

  async change(e) {
    const value = e.target.value;
    console.log("Selected payment_method_id:", value);

    const response = await post(this.urlValue, {
      body: JSON.stringify({
        payment_method_id: value,
      }),
    });

    const data = await response.json;
    this.descriptionTarget.innerHTML = data.description_display_value;
  }
}
